import gql from 'graphql-tag'

export const GENERATE_PAYROLL = gql`
  query generatePayroll($year: Int!, $month: Int!, $typeOfFortnight: Int!, $work_category: Int) {
    generatePayroll(year: $year, month: $month, typeOfFortnight: $typeOfFortnight, work_category: $work_category){
      employee {
        id
        email
        name
        last_name
        mothers_last_name
        sex_text
        fullLastName
        document_type
        document_number
        phone_number,
        assignment {
          position {
            name
          }
          type_of_contract
          condition
          work_type
        },
        insurance {
          type_regime
          afp {
            name
          }
        },
        finance {
          base_salary
          family_allowance
        }
      }
      list_task {
        id
        task_id
        task {
          id
          date
          deleted_at
        }
        time_total_day
        time_total_extra_day_25
        time_total_extra_day_35
      }
      total_extra_25
      total_extra_35
      rem_essalud
      sctr_pension
      sctr_salud
      vida_ley
      vacations_d
      vacations_t
      base_salary
      salary_total
      afp_total
      afp_insurance
      afp_tope
      afp_subtotal
      month_days
      payed_days
      adelantos
      basic_fortnight
      householdAllowance15
      absence
      additional
      additionalTotal
      bouses
      snackDays
      refreshment
      rent
      loan_total
      bond_control {
        id
        amount
        bond_type_id
      }
      discount_control {
        id
        type
        discount_type_id
        amount
        discountType {
          id
          is_law
          name
        }
      }
      advance_control {
        id
        advance_type_id
        discount_date
        amount
      }
      total_permission_days
      amount_permission
      permissions {
        days
        amount
        permission {
          id
          reason_id
          reason {
            id
            description
            abbreviated
            type
            is_active
            has_subsidy
            apply_sunday_discount
          }
          date_start
          date_end
        }
      }
      absent_days
      domingosconpermiso
      absent_amount
      basic_piecework_fortnight
      loan_total_discounted
      totalToPay
      totalAdditionals
      sundayFactor
      sundayPiecework
      sundayFactorAmount
      subsidies
      days_piecework_fortnight
      total_fortnight
      advanceControlWithAfpTotal
      advanceControlWithOutAfpTotal
      bondControlTotal
      has_permission_with_subsidy
      has_permission_with_sunday_discount
      holidays
      holidays_amount
      apply_holidays_amount
      delay
      total_amount_hours_normal
      total_amount_hours_extra_25
      total_amount_hours_extra_35
      holiday_factor
      amount_holiday_discount
      total_extra_double
      amount_of_sundays
      ajenos
    }
  }
`
export const CREATE_PAYROLL = gql`
  mutation createPayroll($payroll: PayrollInput!) {
    createPayroll(input: $payroll) {
      id
      month
      year
      fortnight
      work_category
      total_to_pay
    }
  }
`
export const UPDATE_PAYROLL = gql`
  mutation updatePayroll($payroll: PayrollInput!, $id: ID!) {
    updatePayroll(input: $payroll, id: $id) {
      id
      month
      year
      fortnight
      work_category
      total_to_pay
    }
  }
`

export const GET_WITH_PAGINATION = gql`
  query payrollWithPagination($page: Int!, $first: Int!) {
    payrollWithPagination(page: $page, first: $first) {
      paginatorInfo {
        perPage
        count
        currentPage
        total
        firstItem
      },
      data {
        id
        month
        year
        fortnight
        work_category
        total_to_pay
        created_at
        updated_at
      }
    }
  }
`

export const DELETE_PAYROLL = gql`
  mutation deletePayroll($id: ID!) {
    deletePayroll(id: $id) {
      id
    }
  }
`

export const EXIST_PAYROLL = gql`
  query existPayroll ($year: Int!, $month: Int!, $typeOfFortnight: Int!, $work_category: Int) {
    existPayroll (year: $year, month: $month, typeOfFortnight: $typeOfFortnight, work_category: $work_category) {
      exist
      payroll {
        id
        month
        year
        fortnight
        work_category
        total_to_pay
        amount_of_sundays
        payrollItems {
          id
          payroll_id
          work_type
          type_regime
          employee_id
          employee {
            id
            email
            name
            last_name
            mothers_last_name
            sex_text
            fullLastName
            document_type
            document_number
            phone_number,
            assignment {
              position {
                name
              }
              type_of_contract
              condition
              work_type
            },
            insurance {
              type_regime
              afp {
                name
              }
            },
            finance {
              base_salary
              family_allowance
            }
          }
          base_salary
          family_allowance
          salary_total
          month_days
          afp_total
          payed_days
          days_piecework_fortnight
          basic_fortnight
          basic_piecework_fortnight
          total_extra_25
          total_extra_35
          rem_essalud
          sctr_pension
          sctr_salud
          vida_ley
          vacations_d
          vacations_t
          snack_days
          refreshment
          loan_total
          permissions_days
          amount_permission
          total_additionals
          subsidies
          absent_days
          domingosconpermiso
          absent_amount
          sunday_factor
          sunday_piecework
          sunday_factor_amount
          rent
          loan_total_discounted
          total_to_pay
          advance_control_with_afp_total
          advance_control_with_out_afp_total
          has_permission_with_subsidy
          has_permission_with_sunday_discount
          bond_control_total
          delay
          holidays_amount
          holidays
          apply_holidays_amount
          household_allowance_15
          total_amount_hours_normal
          total_amount_hours_extra_25
          total_amount_hours_extra_35
          holiday_factor
          amount_holiday_discount
          total_extra_double
          adelantos
          ajenos
          amount_of_sundays
          advanceTypes {
            id
            advance_type_id
            amount
            advanceType {
              id
              name
            }
          }
          bondTypes {
            id
            bond_type_id
            amount
            bondType {
              id
              name
            }
          }
          discountTypes {
            id
            discount_type_id
            amount
            type
            discountType {
              id
              name
              is_law
            }
          }
          permissions {
            id
            reason_permission_id
            days
            amount
            reasonPermission {
              id
              description
              abbreviated
              type
              is_active
              status_text
              has_subsidy
            }
          }
        }
        discountTypes {
          id
          discount_type_id
          discountType {
            id
            name
          }
        },
        advanceTypes {
          id
          advanceType {
            id
            name
          }
        }
        bondTypes {
          id
          bondType {
            id
            name
          }
        }
      }
    }
  }
`

export const EMPLOYEE_PAYROLL_LUNCH_DAYS = gql`
  query employeePayrollLunchDays($employee_id: ID!, $year: Int!, $month: Int!, $fortnight: Int!) {
    employeePayrollLunchDays(employee_id: $employee_id, year: $year, month: $month, fortnight: $fortnight) {
      date
      source
      source_label
      item_id
      amount_lunch
      price_lunch
      total
      has_record
    }
  }
`

export const UPDATE_EMPLOYEE_PAYROLL_LUNCH_DAYS = gql`
  mutation updateEmployeePayrollLunchDays($input: UpdatePayrollLunchDaysInput!) {
    updateEmployeePayrollLunchDays(input: $input) {
      snackDays
      refreshment
      days {
        date
        source
        source_label
        item_id
        amount_lunch
        price_lunch
        total
        has_record
      }
    }
  }
`
